import axios from 'axios';
import { SaveIntVal } from '../../Functions/SaveIntVal/SaveIntVal';
import { addCustomProspect } from './AddProspect'
import { HobbyModel } from './NewJuneModels/HobbyModel';
import { InterestedInModel } from './NewJuneModels/InterestedInModel';
import { JobRoleModel } from './NewJuneModels/JobRoleModel';
import { LocationModel } from './NewJuneModels/LocationModel';
import { PersonalValueModel } from './NewJuneModels/PersonalValueModel';
import { QuotesModel } from './NewJuneModels/QuotesModel';
import { TemplateModel } from './NewJuneModels/TemplateModel';
import { WorkEventModel } from './NewJuneModels/WorkEventModel';
import { WorkIntModel } from './NewJuneModels/WorkIntModel';



var arr = [];

//filter interest if no interest label arrived yet to see what model we will use with the classifier (either interest or work goal...
//...company info, personal articles, should come in with the interest already labeled and sent to model)
export const getCustomIntro = async(
    fbProfile,
    vProp,
    int,
    auth,
    setContent,
    setGenerating,
    tokens,
    docID,
    name,
    setDocID,
    setPrevName,
    prevName,
    interestValues,
    msgType,
    callToAction,
    setBtnClicked,
    setEditing,
    teamToken,
    tokensTeam
    ) =>{

    setGenerating(true)
    setBtnClicked(false)
    setEditing(false)

    if(prevName !== name){
    await addCustomProspect(fbProfile, auth, setDocID, name, setPrevName)
    .then(function(newDocId){
        searchData(int, interestValues);
        docID = newDocId
        if(vProp?.ContextType === "template"){
            TemplateModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
        }
        else if(int.includes('"')){
            // console.log("here")
            QuotesModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
        } 
        else if(arr.length > 0){
            if(arr[0].classified === 'Hobby'){
                HobbyModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Work'){
                WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Role'){
                JobRoleModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Location'){
                LocationModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Value'){
                PersonalValueModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Interested In' || arr[0].classified === 'Interested in'){
                InterestedInModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Work Event' || arr[0].classified === 'Work event'){
                WorkEventModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else{
                WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            }
        } else {
            const message= { Input: int }
            axios
            .post('https://boundapiv2.herokuapp.com/newClassifierModel', message)
            .then((response) => {
                let classified = response.data
                SaveIntVal(int, classified);
    
                if(classified === 'Hobby'){
                    HobbyModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Work'){
                    WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Role'){
                    JobRoleModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Location'){
                    LocationModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Value'){
                    PersonalValueModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Interested In' || classified === 'Interested in'){
                    InterestedInModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Work Event' || classified === 'Work event' ){
                    WorkEventModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else{
                    WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                }
            })
        }
    })
    }
    // If name is the same as before
    else {
        searchData(int, interestValues);
        if(int.includes('"')){
            // console.log("here")
            QuotesModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
        } 
        else if(arr.length > 0){
            if(arr[0].classified === 'Hobby'){
                HobbyModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Work'){
                WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Role'){
                JobRoleModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Location'){
                LocationModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Value'){
                PersonalValueModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Interested In' || arr[0].classified === 'Interested in'){
                InterestedInModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else if(arr[0].classified === 'Work Event' || arr[0].classified === 'Work event'){
                WorkEventModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            } 
            else{
                WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
            }
        } else {
            // console.log('axios');
            const message= { Input: int }
            //first classify interest
            axios
            .post('https://boundapiv2.herokuapp.com/newClassifierModel', message)
            .then((response) => {
                let classified = response.data
                SaveIntVal(int, classified);
    
                if(classified === 'Hobby'){
                    HobbyModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Work'){
                    WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Role'){
                    JobRoleModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Location'){
                    LocationModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Value'){
                    PersonalValueModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Interested In' || classified === 'Interested in'){
                    InterestedInModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else if(classified === 'Work Event' || classified === 'Work event' ){
                    WorkEventModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                } 
                else{
                    WorkIntModel(fbProfile, vProp, int, auth, setContent, setGenerating, tokens, docID, name, msgType, callToAction, teamToken,tokensTeam)
                }
            })
        }
    }
}

// STOP HERE ________


//pull that information back into the firebase prospect message generated section

const searchData = (e, projects) => {
    arr = projects.filter(dataContainsTerm(e))
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.intVal.toString().toLowerCase() === word &&
            startsWith(data.intVal.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}

